/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Tpl_Cta_TitleInputs */

const en_fw_tpl_cta_title = /** @type {(inputs: Fw_Tpl_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish your own`)
};

const id_fw_tpl_cta_title = /** @type {(inputs: Fw_Tpl_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbitkan punyamu`)
};

/**
* | output |
* | --- |
* | "Publish your own" |
*
* @param {Fw_Tpl_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_tpl_cta_title = /** @type {((inputs?: Fw_Tpl_Cta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Tpl_Cta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_tpl_cta_title(inputs)
	return en_fw_tpl_cta_title(inputs)
});